// extracted by mini-css-extract-plugin
export default {"support":"SupportButton_support__TXhRG","description":"SupportButton_description__sg9Ra","icon":"SupportButton_icon__eEDvs"};